
import { t } from "elysia";

export const WeatherRiskSchema = t.Object({
	reasoning: t.String(),
	risk: t.Number({
		maximum: 100,
		minimum: 0,
	}),
	type: t.Union([t.Literal("landing"), t.Literal("takeoff")]),
	weatherReport: t.String(),
});

export type RiskLevel = "elevated" | "low" | "moderate";

export type WeatherRisk = typeof WeatherRiskSchema.static;

export const RouteRiskSchema = t.Object({
	reasoning: t.String(),
	risk: t.Number({
		maximum: 100,
		minimum: 0,
	}),
});

export type RouteRisk = typeof RouteRiskSchema.static;
